module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "jay.f3cb02cf.jpg";